import { useCallback } from 'react';
import { marked } from 'marked'; // markdown → HTML
import DOMPurify from 'dompurify'; // sanitise the HTML

/**
 * Returns a function that copies the given markdown string to the clipboard
 * in both plain-text *and* HTML form, so Word keeps the formatting.
 */
export function useCopyMarkdown(markdown: string) {
  return useCallback(async () => {
    // 1. markdown → raw HTML
    const rawHtml = await marked.parse(markdown, { breaks: true });

    // 2. sanitise: never trust HTML you didn't hand-craft
    const safeHtml = DOMPurify.sanitize(rawHtml, {
      USE_PROFILES: { html: true },
    });

    // 3. clipboard payload
    const item = new ClipboardItem({
      'text/html': new Blob([safeHtml], { type: 'text/html' }),
      'text/plain': new Blob([markdown], { type: 'text/plain' }),
    });

    await navigator.clipboard.write([item]);
  }, [markdown]);
}
